import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html, body {
    background: ${({ theme }) => theme.backgrounds.main };
  }
 /*
  * Matches Quest Portal Scrollbar look and feel if we want that
  *
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(75, 64, 58, 0.4);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  }
  */
`;

export default GlobalStyle;